import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, WritableSignal, signal } from '@angular/core';
import { CoilSheet, CoilSheetDataSets } from '../entities/coilSheet';
import { SearchResult } from '../entities/searchResult';
import { SearchCriteria } from '../helpers/search-criteria/search-criteria';
import { EnvironmentConfigService } from './environment-config.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  orderPost = new Subject();
  currentOrderPost = this.orderPost.asObservable();
  OdinHeaderSearchCriteria: SearchCriteria = new SearchCriteria();
  coilSearchCriteria: SearchCriteria = new SearchCriteria();
  orderSearchCriteria: SearchCriteria = new SearchCriteria();

  sResults: WritableSignal<any> = signal([]);

  coilSearchEndpoint: string = `${EnvironmentConfigService.getApiGatewayConfig().SEARCH_ENDPOINT}/coilsheets/fuzzy-search`;
  orderSearchEndpoint: string = `${EnvironmentConfigService.getApiGatewayConfig().SEARCH_ENDPOINT}/orders/fuzzy-search`;
  coilSheetDataSetsEndpoint: string = `${EnvironmentConfigService.getApiGatewayConfig().SEARCH_ENDPOINT}/coilsheetdatasets`;
  coilSheetOrdersEndpoint: string = `${EnvironmentConfigService.getApiGatewayConfig().SEARCH_ENDPOINT}/coilsheets`;
  odinHeaderDataEndpoint: string = `${EnvironmentConfigService.getApiGatewayConfig().SEARCH_ENDPOINT}/odin/coil-header`;
  odinQuantiyStatusDataEndpoint: string = `${EnvironmentConfigService.getApiGatewayConfig().SEARCH_ENDPOINT}/odin/quantity-status`;
  odinCoilStatusDataEndpoint: string = `${EnvironmentConfigService.getApiGatewayConfig().SEARCH_ENDPOINT}/odin/coil-status`;
   odinHeaderDataEndpointCoil: string = `${EnvironmentConfigService.getApiGatewayConfig().SEARCH_ENDPOINT}/odin/coil-header`;
    odinHeaderDataEndpointOrder: string = `${EnvironmentConfigService.getApiGatewayConfig().SEARCH_ENDPOINT}/odin/order-header`;

  constructor(private http: HttpClient) { }


  updateOrderPoste(newOrder: string) {
    this.orderPost.next(newOrder);
  }

  get searchResults() {
    return this.sResults();
  }

  setSearchResults(results: SearchResult) {
    this.sResults.set(results);
  }

  searchCoils(searchCriteria: SearchCriteria, data: any) {
    this.coilSearchCriteria = searchCriteria;
    let params = new HttpParams();
    params = this.checkingParameters(searchCriteria, params);
    let CompanyList;
    if (data) {
      CompanyList = data.companyList;
    }
    return this.http.post<SearchResult>(this.coilSearchEndpoint, CompanyList, { params });
  }

  getCoilSheetDataSets(_idCoilSheet: string, name: string) {
    const updateEndpoint = `${this.coilSheetDataSetsEndpoint}/${_idCoilSheet}/${name}`;
    return this.http.get<CoilSheetDataSets>(updateEndpoint);
  }

  searchOrders(searchCriteria: SearchCriteria, data: any) {
    this.orderSearchCriteria = searchCriteria;
    let params = new HttpParams();
    params = this.checkingParameters(searchCriteria, params);
    let CompanyList;
    if (data) {
      CompanyList = data.companyList;
    }
    return this.http.post<SearchResult>(this.orderSearchEndpoint, CompanyList, { params });
  }

  getCoilSheetOrders(_idOrder: string) {
    const updateEndpoint = `${this.coilSheetOrdersEndpoint}/${_idOrder}`;
    return this.http.get<CoilSheet[]>(updateEndpoint);
  }

  checkingParameters(searchCriteria: SearchCriteria, params: HttpParams) {
    // insert the size of search as default
    params = params.set('size', searchCriteria.size);
    if (searchCriteria.searchText) {
      params = params.set('searchText', searchCriteria.searchText);
    }


    if (searchCriteria.sortField) {
      params = params.set('sort', searchCriteria.sortField + ',' + searchCriteria.sort);
    }

    if (searchCriteria.page) {
      params = params.set('page', searchCriteria.page);
    }
    return params;
  }


  getOdinHeaderData(searchCriteria: SearchCriteria) {
    this.OdinHeaderSearchCriteria = searchCriteria;

    let paramsOdin = new HttpParams();
    paramsOdin = this.checkingParameters(searchCriteria, paramsOdin);
    return this.http.post<any>(this.odinHeaderDataEndpoint, null, { params: paramsOdin });
  }
   getOdinHeaderDataCoil(searchCriteria: SearchCriteria,Companydata: any) {
    this.OdinHeaderSearchCriteria = searchCriteria;

    let paramsOdin = new HttpParams();
    paramsOdin = this.checkingParameters(searchCriteria, paramsOdin);
    return this.http.post<any>(this.odinHeaderDataEndpointCoil, Companydata, { params: paramsOdin });
  }
   getOdinHeaderDataOrder(searchCriteria: SearchCriteria,Companydata: any) {
    this.OdinHeaderSearchCriteria = searchCriteria;

    let paramsOdin = new HttpParams();
    paramsOdin = this.checkingParameters(searchCriteria, paramsOdin);
    return this.http.post<any>(this.odinHeaderDataEndpointOrder, Companydata, { params: paramsOdin });
  }
  getOdinCoilStatusData(customerPO: any) {
    const odinCoilStatusurl = `${this.odinCoilStatusDataEndpoint}/${customerPO}`;
    return this.http.post<any>(odinCoilStatusurl, {});
  }
  getOdinQuantityStausData(orderPost: any) {
    const odinQuantotyStatusurl = `${this.odinQuantiyStatusDataEndpoint}/${orderPost}`;
    return this.http.post<any>(odinQuantotyStatusurl, {});
  }
}
